(function(){
  if(window.__vqSearchBoot) return; window.__vqSearchBoot = 1;
  /* GA4 bridge: the Shopify Google-app pixel is sandboxed (no window.gtag), so vq_* funnel events had no
     path to GA4. Load our own sender on the SAME property with send_page_view:false (no double-counting). */
  /* 06-Sep/08-Sep: this used to run at PARSE TIME. The sandboxed Shopify Google pixel never sets
     window.gtag, so the guard never failed -- this config call ran on EVERY page load and STARTED
     the GA4 session, while the real page_view arrives much later from Shopify's pixel. Any visit
     ending in that gap produced a session with session_start + user_engagement but NO page_view,
     which GA4 records as landing page "(not set)": 20,481 sessions / 90 days (16% of all), 96.2%
     bounce, 46% google/cpc desktop. See GA4-NOTSET-DIAGNOSIS-2026-09-06.md.
     It also cost 181 KB of gtag/js on the critical path before first paint (PDP-PERF-AUDIT-2026-09-08).
     Fix: initialise lazily on the first vq_ event. Those fire only after user interaction, by which
     time Shopify's pixel has sent page_view, so this sender can no longer create a page_view-less
     session -- and the 181 KB no longer blocks first paint. No event is lost. */
  function vqGtagInit(){
    if(window.__vqGtagReady) return;
    window.__vqGtagReady = 1;
    window.dataLayer = window.dataLayer || [];
    if(!window.gtag){ window.gtag = function(){ dataLayer.push(arguments); }; }
    gtag('js', new Date());
    gtag('config', 'G-S0CW4S4X6M', { send_page_view: false });
    var gs = document.createElement('script');
    gs.async = true; gs.className = 'shopify-vividads';
    gs.src = 'https://www.googletagmanager.com/gtag/js?id=G-S0CW4S4X6M';
    document.head.appendChild(gs);
  }
  var VQ_MOBILE = window.matchMedia('(max-width:749px)').matches;
  function track(ev, data){
    try{
      vqGtagInit();
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev }; for(var k in (data||{})) o[k] = data[k];
      dataLayer.push(o);
      if(window.gtag) gtag('event', ev, data || {});
    }catch(e){}
  }
  function esc(t){ return String(t).replace(/[<>"]/g, ''); }
  function recents(){ try{ return JSON.parse(localStorage.getItem('vq_recent_searches')||'[]'); }catch(e){ return []; } }
  function saveRecent(t){
    try{
      t = String(t).trim().slice(0, 40); if(!t) return;
      var r = recents().filter(function(x){ return x.toLowerCase() !== t.toLowerCase(); });
      r.unshift(t); localStorage.setItem('vq_recent_searches', JSON.stringify(r.slice(0, 5)));
    }catch(e){}
  }
  /* dispatch promise — same business-day + 3PM Sydney cutoff logic as the product-page teaser */
  function dispDate(pid){
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
    function biz(d){ var w = d.getDay(); return w !== 0 && w !== 6; }
    var days = (String(pid) === '1666855829573') ? 3 : 1;
    var start = (biz(now) && now.getHours() < 15) ? new Date(now) : (function(){ var x = new Date(now); do{ x.setDate(x.getDate()+1); }while(!biz(x)); return x; })();
    var d = new Date(start), n = days;
    while(n > 0){ d.setDate(d.getDate()+1); if(biz(d)) n--; }
    return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Australia/Sydney' });
  }
  function renderRecent(dd){
    if(!dd) return;
    var r = recents();
    var box = dd.querySelector('.vq-recent');
    if(!r.length){ if(box) box.remove(); return; }
    if(!box){ box = document.createElement('div'); box.className = 'vq-recent'; dd.appendChild(box); }
    box.innerHTML = '<span class="vq-rec-label">Recent searches</span><ul>' + r.map(function(t){
      return '<li><a href="/search?q=' + encodeURIComponent(t) + '&type=product&options%5Bprefix%5D=last">' + esc(t) + '</a></li>';
    }).join('') + '</ul>';
  }
  function wire(){
    document.querySelectorAll('.search__input').forEach(function(input){
      if(input.__vqSearchWired) return; input.__vqSearchWired = true;
      var form = input.closest('form');
      if(!form) return;
      var dd = form.querySelector('.dropdown-search');
      var sg = form.querySelector('.vq-suggest');
      if(!sg){ sg = document.createElement('div'); sg.className = 'vq-suggest'; form.appendChild(sg); }
      function showTrending(){ if(dd && !input.value.trim()){ if(VQ_MOBILE) renderRecent(dd); dd.classList.add('visible-search'); } }
      function hideTrending(){ if(dd) dd.classList.remove('visible-search'); }
      /* typewriter guard: the theme's rotating-keyword animation writes directly into input.value and,
         until its deferred JS attaches its own focus handler, it fights the user's first keystrokes
         (measured: typed "banner" became "Gazebos"). While the field is focused, the user's value wins. */
      var userVal = null;
      input.addEventListener('focus', function(){
        if(userVal === null){ userVal = ''; if(input.value){ input.value = ''; } }
        else { userVal = input.value; }
      });
      input.addEventListener('blur', function(){ userVal = null; });
      input.addEventListener('input', function(){ if(userVal !== null) userVal = input.value; });
      setInterval(function(){
        if(document.activeElement === input && userVal !== null && input.value !== userVal){
          input.value = userVal;
        }
      }, 180);
      input.addEventListener('focus', function(){
        if(!input.__vqOpened){ input.__vqOpened = 1; track('vq_search_opened'); }
        if(!input.value.trim()) showTrending();
      });
      form.addEventListener('submit', function(){ var v = input.value.trim(); if(v){ saveRecent(v); track('vq_search_submitted', { search_term: v }); } });
      sg.addEventListener('click', function(e){
        var a = e.target.closest('a'); if(!a) return;
        var v = input.value.trim();
        if(a.classList.contains('vq-sg-all')){ if(v){ saveRecent(v); track('vq_search_submitted', { search_term: v }); } }
        else { saveRecent(v); track('vq_search_suggestion_clicked', { search_term: v, product_title: (a.querySelector('.vq-sg-title')||{textContent:''}).textContent }); }
      }, true);
      var deb;
      input.addEventListener('input', function(){
        var v = input.value.trim();
        if(!v){ sg.style.display = 'none'; sg.innerHTML = ''; showTrending(); return; }
        hideTrending();
        clearTimeout(deb);
        deb = setTimeout(function(){
          fetch('/search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6')
            .then(function(r){ return r.json(); })
            .then(function(j){
              if(input.value.trim() !== v) return;
              var prods = (j.resources && j.resources.results && j.resources.results.products) || [];
              var h = '';
              prods.forEach(function(p){
                var img = (p.featured_image && p.featured_image.url) || p.image || '';
                var price = p.price_min || p.price;
                h += '<a href="' + p.url + '">' +
                     (img ? '<img src="' + img + '&width=80" width="40" height="40" loading="lazy" alt="">' : '') +
                     '<span class="vq-sg-main">' +
                       '<span class="vq-sg-title">' + esc(p.title) + '</span>' +
                       (p.type ? '<span class="vq-sg-cat">' + esc(p.type) + '</span>' : '') +
                       '<span class="vq-sg-disp">\u2713 Dispatches ' + dispDate(p.id) + '</span>' +
                     '</span>' +
                     (price ? '<span class="vq-sg-price">From $' + esc(price) + '<i>inc GST</i></span>' : '') + '</a>';
              });
              h += '<a class="vq-sg-all" href="/search?q=' + encodeURIComponent(v) + '&type=product&options%5Bprefix%5D=last">Search for &ldquo;' + esc(v) + '&rdquo; &rsaquo;</a>';
              sg.innerHTML = h; sg.style.display = 'block';
            }).catch(function(){});
        }, 220);
      });
    });
  }
  document.addEventListener('click', function(e){
    document.querySelectorAll('.dropdown-search.visible-search, .vq-suggest').forEach(function(el){
      var form = el.closest('form');
      var input = form ? form.querySelector('.search__input') : null;
      if((!input || !input.contains(e.target)) && !el.contains(e.target)){
        el.classList.remove('visible-search');
        if(el.classList.contains('vq-suggest')) el.style.display = 'none';
      }
    });
  }, true);
  if(document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);
  setTimeout(wire, 1200);
})();
